// Generated by purs version 0.15.0
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
var Period = /* #__PURE__ */ (function () {
    function Period(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Period.create = function (value0) {
        return function (value1) {
            return new Period(value0, value1);
        };
    };
    return Period;
})();
var countryRomania = /* #__PURE__ */ (function () {
    return Restaumatic_TypesGen.RO.value;
})();
var countryGreatBritain = /* #__PURE__ */ (function () {
    return Restaumatic_TypesGen.GB.value;
})();
export {
    countryGreatBritain,
    countryRomania,
    Period
};
export {
    DishGroupId,
    DishId,
    DrinkId,
    DrinkSize,
    PanType,
    PizzaId,
    PizzaSize,
    SideDishId,
    SideId,
    ToppingId
} from "../Restaumatic.Menu.Types.Id/index.js";
export {
    RestaurantId
} from "../Restaumatic.Restaurant.Types.Id/index.js";
export {
    BR,
    CZ,
    DE,
    ES,
    GB,
    HR,
    NL,
    PL,
    RO,
    RU,
    SK,
    BRL,
    CZK,
    EUR,
    GBP,
    HRK,
    PLN,
    RON,
    RUB,
    USD,
    allCountries,
    allCurrencies
} from "../Restaumatic.TypesGen/index.js";
//# sourceMappingURL=index.js.map
